module.exports = __webpack_public_path__ + "img/tab2-2@2x.eadf748e.png";